// src/analytics/consent.js
import { trackPageView } from "./ga";
import endpoints from "../api/endpoints";

const CONSENT_KEY = "rn_cookie_consent_v1";
export const CONSENT_BANNER_VERSION = "2026-02-25";
export const PRIVACY_POLICY_VERSION = "2026-02-03";
export const CONSENT_BANNER_TEXT = [
  "Cookies and analytics",
  "We use cookies to operate our site and analyze usage to improve our services. You can manage your preferences at any time in Cookie Settings.",
  "Cookie Preferences",
  "Continue",
].join("|");

function hashString(input) {
  let hash = 5381;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash * 33) ^ input.charCodeAt(i);
  }
  return (hash >>> 0).toString(16);
}

export function getStoredConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.analytics === "accepted" || parsed?.analytics === "rejected") {
      return parsed;
    }
  } catch {
    return null;
  }
  return null;
}

export function setStoredConsent(analyticsValue) {
  if (typeof window === "undefined") return;
  const payload = {
    analytics: analyticsValue,
    updated_at: new Date().toISOString(),
  };
  window.localStorage.setItem(CONSENT_KEY, JSON.stringify(payload));
}

export function enableAnalytics() {
  if (typeof window === "undefined") return;
  window.__DISABLE_GA__ = false;
  if (typeof window.__loadGA__ === "function") {
    window.__loadGA__();
  }
  const path = window.location.pathname + window.location.search;
  trackPageView(path);
}

export function disableAnalytics() {
  if (typeof window === "undefined") return;
  window.__DISABLE_GA__ = true;
}

export async function recordConsent(analyticsValue, source = "banner", isEu = null) {
  try {
    await fetch(endpoints.CONSENT_RECORD, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        analytics: analyticsValue,
        source,
        banner_version: CONSENT_BANNER_VERSION,
        policy_version: PRIVACY_POLICY_VERSION,
        banner_text_hash: hashString(CONSENT_BANNER_TEXT),
        is_eu: isEu,
      }),
    });
  } catch {
    // Best-effort logging only.
  }
}
